import { render } from "./ScaleOneToFive.vue?vue&type=template&id=a3f06b88"
import script from "./ScaleOneToFive.vue?vue&type=script&lang=js"
export * from "./ScaleOneToFive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])